import type { GroupEntity, GroupMemberRole } from '@group/domain';
import type { UserEntity } from '@user/UserEntity';
import type { SelectedWorkspaceItem } from './InvitePageWorkspaceList';
import { WorkspaceMemberRole } from '@workspace/domain/workspace';
import type { WorkspaceMemberRoleJSON, WorkspaceId } from 'balus-common';
import { trpcClient } from '@framework/trpcClient';

export const MAX_INVITATION_COUNT = 100;

// グループメンバー招待を作成し、招待メールを送信する
export const createGroupMemberInvitations = async (
  group: GroupEntity,
  sender: UserEntity,
  emails: string[],
  memberRole: GroupMemberRole,
  workspaces: SelectedWorkspaceItem[],
  message: string
): Promise<void> => {
  if (emails.length < 1 || emails.length > MAX_INVITATION_COUNT) {
    throw new Error(`招待メールの数は1通以上${MAX_INVITATION_COUNT}通以下である必要があります。`);
  }

  await trpcClient.group.sendGroupMemberInvitation.mutate({
    groupId: group.id,
    workspaces: convertWorkspaces(workspaces),
    memberRole,
    emails,
    message,
  });
};

const convertWorkspaces = (
  workspaces: SelectedWorkspaceItem[]
): Record<WorkspaceId, WorkspaceMemberRoleJSON> | null => {
  const result: Record<WorkspaceId, WorkspaceMemberRoleJSON> = {};
  workspaces.forEach((item) => {
    result[item.workspaceId] = WorkspaceMemberRole.dump(item.role) as WorkspaceMemberRoleJSON;
  });
  return Object.keys(result).length ? result : null;
};
